import script from "./staff.vue?vue&type=script&setup=true&lang=js"
export * from "./staff.vue?vue&type=script&setup=true&lang=js"

import "./staff.vue?vue&type=style&index=0&id=8d4bb78c&lang=stylus"

const __exports__ = script;

export default __exports__